<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-configurations-company-configuration">
    <v-jsoneditor v-if="isRoleAllow(900004)" v-model="json" :show-btns="false" :exapndedOnStart="true" mode="code" :modes="['code']" @json-change="onJsonChange()" @has-error="onJsonError()" />
    <div v-else style="overflow-y: scroll;"><vue-json-editor :data="json" :showLine="true"></vue-json-editor></div>
    <div v-if="isChanged && !hasError" class="div-confirm-btn"><el-button class="btn-confirm" type="primary" @click="handleUpdateCompanyConfigure">Confirm Changes</el-button></div>
  </div>
</template>

<script>
import VJsoneditor from 'vue-json-editor'
import {mapGetters, mapMutations, mapActions} from 'vuex';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

//v-jsoneditor
export default {
  modalTitle: 'Company Configuration',
  components: {
      'v-jsoneditor': VJsoneditor,
      'vue-json-editor': VueJsonPretty
  },

  computed: {
    ...mapGetters(['authUser', 'isSysAdminUser', 'isRoleAllow']),

    isChanged() {
      return JSON.stringify(this.json) != JSON.stringify(this.cloneJson)
    }
  },

  data() {
    return {
      json: {},
      cloneJson: {},
      hasError: false,
      preMsgObj: null,

      // options: { mode: 'code' }
    };
  },

  methods: {
    ...mapMutations(['resetDataModel']),
    ...mapActions(['updateCompanyConfiguration', 'createCompanyConfiguration', 'fetchCompanyConfiguration']),

    async handleUpdateCompanyConfigure() {
      let data = {
        key: this.authUser.companyId,
        config: this.json
      }
      this.disabledBtn = true;
      let res = await this.updateCompanyConfiguration(data);
      if(res.status == 200) {
        this.cloneJson = JSON.parse(JSON.stringify(this.json));
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 1000,
            showClose: true,
            customClass: 'update-success-msg',
            message: 'Updated successfully',
            onClose: ()=>{
              this.preMsgObj = null;
              window.location.keepDefaultPath = true;
              window.location.reload();
            }
          });
        }
      }
      else{
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 3000,
            showClose: true,
            customClass: 'update-failed-msg',
            message: 'Update failed',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
      this.hasError = false;
    },

    onJsonError() {
      this.hasError = true
    },
    onJsonChange() {
      this.hasError = false
    }
  },

  async created() {
    let companyConfig = await this.fetchCompanyConfiguration();
    if(companyConfig && Object.keys(companyConfig).length > 0) {
      this.json = companyConfig;
      this.cloneJson = JSON.parse(JSON.stringify(this.json));
    }
    else {
      this.json = {}
    }
  }
};
</script>

<style lang="scss">
.wy-configurations-company-configuration {
  height: 100%;
  padding: 10px 15px 10px 10px;

  > div {
    height: calc(100% - 60px);

    .jsoneditor-vue {
      height: 100%;
    }
  }

  .div-confirm-btn {
    // display: inline-block;
    float: right;
    padding-top: 20px;
    padding-right: 12px;
    width: 158px;
    .btn-confirm {
      background-color: #214586;
      padding: 7px 30px 7px 30px;
    }
  }
  
  .jsoneditor.jsoneditor-mode-code {
    border: 1px solid #eee;
    border-radius: 3px;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    
    .ace_gutter {
      background-color: #eee;
    }

    .jsoneditor-menu {
      background-color: #E2ECF7;
      border-bottom: #ddd;
      padding: 7px;
      height:43px;

      > button {
        background-color: #214586;
      }

      .jsoneditor-modes {
        display: none;
      }
      .jsoneditor-poweredBy {
        display: none;
      }
    }
  }  
}
</style>
